import { Box } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const StyledLandingComponentContainer = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(8)} ${theme.spacing(6)} ${theme.spacing(10)}`,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(10),
  maxWidth: theme.spacing(360),
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(34),
    paddingRight: theme.spacing(34),
  },
}));

export const StyledLandingComponentContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));
